<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title">
			<v-form ref="form" v-model="valid">
				<v-container>
					<v-row no-gutters justify="space-between">
						<h5 class="text-body-1 font-weight-bold">選択された案件データ</h5>
					</v-row>
					<v-row no-gutters>
						<h6 class="font-weight-bold mr-2">対象案件</h6>
						<p>
							<a @click="openMatterDialog">
								{{ selectedMatter.name }}
							</a>
						</p>
					</v-row>
					<v-divider class="my-4" />
					<v-row no-gutters class="mt-4" justify="end">
						<v-btn color="secondary" :disabled="!valid" @click="submitForm('draft')">
							<v-icon class="mr-1">mdi-content-save-outline</v-icon> 下書き保存
						</v-btn>
						<v-btn class="ml-2" color="secondary" :disabled="!valid" @click="openConfirmDialog">
							<v-icon class="mr-1">mdi-plus</v-icon> 作成して確認を依頼
						</v-btn>
					</v-row>
					<QuotationForm :quotation_data.sync="quotation" />
				</v-container>
			</v-form>
		</CommonFlame>
		<QuotationConfirmDialog
			:dialog.sync="confirmDialog"
			:matter="selectedMatter"
			:quotation="quotation"
		/>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"

import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import QuotationForm from "./components/QuotationForm.vue"
import QuotationConfirmDialog from "./components/QuotationConfirmDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		QuotationForm,
		QuotationConfirmDialog,
	},
	data() {
		return {
			title: "見積編集",
			quotation: {
				files: [],
			},
			selectedMatter: {},

			confirmDialog: false,

			valid: false,
			errors: [],
			rules,
		}
	},
	mounted() {
		this.fetchQuotation()
	},
	methods: {
		fetchQuotation() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/quotations/${this.id}/edit`
			axios
				.get(url, { headers })
				.then((res) => {
					this.quotation = res.data.quotation
					this.selectedMatter = res.data.matter
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openMatterDialog() {
			// TODO
		},
		openConfirmDialog() {
			this.confirmDialog = true
		},
		submitForm(status) {
			// TODO
			const headers = authenticate.setHeader()
			const params = { quotation: this.quotation }
			const url = "/erp/v1/quotations"
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$router.push({ name: "quotation_index" })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}
</script>